import '@/shared/styles/global.css'

export const Spinner = () => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: 'var(--bg)', color: 'var(--text)' }}>
    Loading…
  </div>
)

// Shown while the RP-initiated logout navigation is in flight (the stored user is
// already gone by then). Named, rather than the generic spinner, because "Loading…"
// after clicking Sign out reads like something went wrong.
export const SigningOut = () => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: 'var(--bg)', color: 'var(--text2)', fontFamily: 'var(--body)', fontSize: '0.9rem' }}>
    Signing out…
  </div>
)
